import {
  getGridBooleanOperators,
  getGridDateOperators,
  getGridNumericOperators,
  getGridSingleSelectOperators,
  getGridStringOperators
} from '@mui/x-data-grid';

export const filterOperators = getGridStringOperators().filter(({ value }) =>
  ['contains', 'equals', 'startsWith', 'endsWith', 'isEmpty', 'isNotEmpty'].includes(value)
);
export const filterListOperators = getGridStringOperators().filter(({ value }) =>
  ['contains'].includes(value)
);

// 2. Filtri Numerici: in MUI v6 l'operatore '!=' (oppure 'not') è NATIVO!
// Filtriamo includendo anche l'operatore nativo di disuguaglianza.
export const numberFilterOperators = getGridNumericOperators().filter(({ value }) =>
  ['=', '>', '>=', '<', '<=', '!=', 'not'].includes(value)
);

export const dateFilterOperators = getGridDateOperators().filter(({ value }) =>
  ['is', 'after', 'onOrAfter', 'before', 'onOrBefore'].includes(value)
);

export const booleanFilterOperators = getGridBooleanOperators().filter(({ value }) =>
  ['is'].includes(value)
);

export const singleSelectFilterOperators = getGridSingleSelectOperators().filter(({ value }) =>
  ['is'].includes(value)
);
